import { z } from 'zod';

export type AdminV2TranslationProviderProgress = {
  stage: 'requesting' | 'receiving' | 'parsing';
  receivedCharacters: number;
  provider?: string;
};

export const adminV2LocalizedTextSchema = z
  .object({
    en: z.string(),
  })
  .catchall(z.string());

export const adminV2TranslationMetadataSchema = z.object({
  sourceLocale: z.literal('en'),
  locales: z.record(
    z.string().min(1),
    z.object({
      sourceItemTextHashes: z.record(z.string().min(1), z.string().min(1)),
    })
  ),
});

export type AdminV2LocalizedText = z.infer<typeof adminV2LocalizedTextSchema>;
export type AdminV2TranslationMetadata = z.infer<
  typeof adminV2TranslationMetadataSchema
>;

export function hasAdminV2LocalizedTextValue(
  value: Record<string, string> | undefined
) {
  return Object.values(value ?? {}).some((text) => text.trim().length > 0);
}

export function requireAdminV2LocalizedText(
  value: Record<string, string> | undefined,
  fieldPath: string
) {
  if (!hasAdminV2LocalizedTextValue(value)) {
    throw new Error(`${fieldPath} is required.`);
  }
}

export function requireAdminV2LocalizedTextForLocales(
  value: Record<string, string> | undefined,
  fieldPath: string,
  supportedLocales: readonly string[]
) {
  requireAdminV2LocalizedText(value, fieldPath);
  for (const locale of supportedLocales) {
    if (!value?.[locale]?.trim()) {
      throw new Error(`${fieldPath}.${locale} is required.`);
    }
  }
}
